export default __webpack_public_path__ + "static/media/besan_laddoo.73f9e4a7.png";